
import React, { useId, useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";
import "../../css/TerminosDelSorteo.css";

const TerminosDelSorteo = () => {
  const [isOpen, setIsOpen] = useState(false);
  const contentId = useId();

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <section className={`content-modal ${isOpen ? "is-open" : ""}`}>
      {/* Encabezado */}
      <button
        type="button"
        className="content-modal-titulo"
        onClick={toggleAccordion}
        aria-expanded={isOpen}
        aria-controls={contentId}
      >
        <span className="titulo-term">
          Términos del sorteo
        </span>

        <span className="content-modal-icon" aria-hidden="true">
          {isOpen ? <FiMinus /> : <FiPlus />}
        </span>
      </button>

      {/* Contenido legal */}
      {isOpen && (
        <div
          id={contentId}
          className="context-modal"
          role="region"
          aria-label="Protección de datos personales y aviso legal"
        >
          <p>
            En Alfin Banco cuidamos tu información, el tratamiento de datos
            personales se realiza conforme a lo establecido en la Ley
            N.º 29733 - Ley de Protección de Datos Personales, su Reglamento
            aprobado por D.S. N.º 016-2024-JUS, y las Políticas de Privacidad
            de Alfin Banco disponible en:{" "}
            <a
              href="https://www.alfinbanco.pe/politicasdeprivacidad"
              target="_blank"
              rel="noopener noreferrer"
            >
              Políticas de Privacidad de Alfin Banco
            </a>
            . No usaremos tu información para otros fines sin tu consentimiento
            expreso. Los datos personales serán conservados mientras no
            revoques tu consentimiento y dentro del plazo de conservación
            establecido por ley conforme a lo dispuesto en la Ley N.º 29733
            y su Reglamento aprobado por el Decreto Supremo N.º 016-2024-JUS.
          </p>

          <p>
            Además, conforme a la Ley N° 29733- Ley de Protección de Datos
            Personales y su reglamento aprobado D.S. N.°016-2024-JUS, el
            participante podrá ejercer sus derechos ARCO (Acceso,
            Rectificación, Cancelación u Oposición), presentando la solitud
            en cualquiera de nuestras agencias o nuestra página WEB{" "}
            <a
              href="https://abancodigital.atlassian.net/servicedesk/customer/portal/57/group/111/create/409"
              target="_blank"
              rel="noopener noreferrer"
            >
              Solicitud de derechos ARCO
            </a>
            .
          </p>
          
        </div>
      )}
    </section>
  );
};

export default TerminosDelSorteo;